export const PATHS = {
	HOME: "/",
	FAQ: "/faqs",
	ABOUT: "/about",
	BEGIN: "/begin",
};
